import {axiosInstance as mantis} from "src/api/mantis";

export const getProductList = () => {
    return mantis.get(`/product`);
};
